import Box from '@mui/joy/Box'
import { EmbeddedCheckout, EmbeddedCheckoutProvider } from '@stripe/react-stripe-js'
import { loadStripe, type Stripe } from '@stripe/stripe-js'
import { type FC, memo, useEffect, useState } from 'react'

const PUBLIC_STRIPE_KEY =
  'pk_test_51NtAToCvSLNV5mliw7GHynLeQARKVc5cMOZQoTd8eir7VDyowI4k7t5Gj2T7Y00UjUcCIELZgKV5gzaeaRnsfEeA00X0VgKYv2'

const StripeCheckoutFrame: FC<{ clientSecret: string | null; onComplete?: () => void }> = ({
  clientSecret,
  onComplete,
}) => {
  const [stripe, setStripe] = useState<Stripe | null>(null)

  const loadAndSetStripe = async (): Promise<void> => {
    const stripe = await loadStripe(PUBLIC_STRIPE_KEY)
    setStripe(stripe)
  }

  useEffect(() => {
    void loadAndSetStripe()
  }, [])

  return (
    <Box
      id="stripe_checkout"
      sx={{
        width: '100%',
        maxWidth: 1080,
        minHeight: { xs: 480, md: 655 },
        maxHeight: '95vh',
        overflow: 'auto',
        borderRadius: '8px',
        padding: { xs: '8px', md: '16px' },
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        background: '#ffffff',
      }}
    >
      {stripe !== null && clientSecret !== null && (
        <Box
          sx={{
            flex: 1,
            overflow: 'auto',
          }}
        >
          <EmbeddedCheckoutProvider
            key="stripe"
            stripe={stripe}
            options={{ clientSecret, onComplete }}
          >
            <EmbeddedCheckout />
          </EmbeddedCheckoutProvider>
        </Box>
      )}
    </Box>
  )
}

export default memo(StripeCheckoutFrame)
